export default __webpack_public_path__ + "static/media/section2-bg-mobile.39fbc89d.webp";